// extracted by mini-css-extract-plugin
module.exports = {"globals":"\"../GlobalStyles.css\"","activeColor":"#7cf4fe","uiBlack":"#000000","screen-min":"639px"};